import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from '../icon/svg/checkmark-icon';
import {Body} from '../typography/body';

import styles from './trial-gathering-pill-carousel.module.css';

type Props = {
    pills: string[];
};

const CYCLE_DURATION_SECONDS = 3;

export function TrialGatheringPillCarousel(props: Props) {
    const totalDuration = props.pills.length * CYCLE_DURATION_SECONDS;

    return (
        <div
            // @ts-expect-error
            style={{'--total-duration': `${totalDuration}s`}}
            className={styles['carousel-container']}
        >
            {props.pills.map((pillText, index) => {
                const animationDelay = index * CYCLE_DURATION_SECONDS;
                const pillKey = getPillKey(index);

                return (
                    <div
                        key={pillKey}
                        style={{
                            // @ts-expect-error
                            '--animation-delay': `${animationDelay - CYCLE_DURATION_SECONDS * 3}s`,
                        }}
                        className={styles.pill}
                    >
                        <CheckmarkIcon alignCenter={true} fill={colors.blue} size={20} />
                        <Body size='large' color='dark'>
                            {pillText}
                        </Body>
                    </div>
                );
            })}
        </div>
    );
}

const getPillKey = (index: number) => `pill-${index}`;
